// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase config object
const firebaseConfig = {
  apiKey: "AIzaSyBdUQ1vux_cxZrGt_uh0kSxe5ejkFOup_k",
  authDomain: "optolog-e04c2.firebaseapp.com",
  databaseURL: "https://optolog-e04c2-default-rtdb.firebaseio.com",
  projectId: "optolog-e04c2",
  storageBucket: "optolog-e04c2.firebasestorage.app",
  messagingSenderId: "142975710304",
  appId: "1:142975710304:web:7e73c4cb22f3708cbf7f05",
  measurementId: "G-JLYM8G00VY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the authentication and Firestore services
export const auth = getAuth(app);
export const db = getFirestore(app);
